import React, { ReactElement, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import {
  InstantSearch,
  InfiniteHits,
  Configure,
} from 'react-instantsearch-dom';
import { NoResults } from '../../search/widgets';

import { ALGOLIA_BREED_INDEX, publiclySearchableBreedAttributes } from '../../../utils/constants';
import BreedCard from '../card/breed-card';
import useURLSync from '../../../hooks/useURLSync';
import DebouncedSearchBox from '../../search/widgets/DebouncedSearchBox';
import useCurrentUser from '../../../utils/hooks/useCurrentUser';
import { useAlgoliaSearchClientLite } from '../../../utils/hooks/useAlgoliaSearchClient';

const Hit: React.FC = (props: any) => {
  const { hit, listingsType } = props;

  // Hide the pre-rendered content when the hits load
  useEffect(() => {
    const { hit: hitProperty } = hit;
    const { __position } = hitProperty;
    // Only need to run this on the first hit
    if (__position === 1) {
      const initialView = document.getElementById('breeds-initial-print');
      if (initialView && !initialView.classList.contains('d-none')) {
        initialView.classList.add('d-none');
      }
    }
  }, []);

  return (
    <div className="react-breed-card">
      <BreedCard breed={hit.hit} listingsType={listingsType} key={hit.objectID} />
    </div>
  );
};

const Search = (props: any) => {
  const { currentUser } = useCurrentUser();
  const { createURL } = useURLSync([], false);
  const { breeds, listingsType } = props;
  const containerRef: any = useRef(null);

  const breedFilter = breeds ? JSON.parse(breeds).map((breed: any) => {
    return `id=${breed.id}`;
  }).join(' OR ') : undefined;

  const { searchClient } = useAlgoliaSearchClientLite(currentUser?.public_key);

  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={ALGOLIA_BREED_INDEX!}
      createURL={createURL}
    >
      <div className="row d-flex mb-3 justify-content-between mw-100">
        <div className="col-md-4">
          <DebouncedSearchBox
            placeholder="Search for breeds..."
            useNativeStyles
          />
        </div>
      </div>
      <section className="results-container">
        <Configure
          filters={breedFilter}
          attributesToSnippet={['description:2']}
          snippetEllipsisText="…"
          removeWordsIfNoResults="allOptional"
          restrictSearchableAttributes={publiclySearchableBreedAttributes}
        />

        <main className="search-results-container" ref={containerRef}>
          <section className="container-results">
            <InfiniteHits hitComponent={(hit) => (
              // @ts-ignore
              <Hit hit={hit} listingsType={listingsType} />
            )}
            />
            <NoResults />
          </section>
        </main>
      </section>
    </InstantSearch>
  );
};

const BreedsSearchComponent = Search;

const BreedsSearchContainer: React.FC<any> = (props: any): ReactElement => {
  return (
    <BreedsSearchComponent {...props} />
  );
};

export default BreedsSearchContainer;

if (document.getElementById('react-puppy-breeds-container')) {
  const element = document.getElementById('react-puppy-breeds-container');
  const breeds = element?.getAttribute('data-breeds');
  const listingsType = element?.getAttribute('data-listingsType');
  ReactDOM.render(<BreedsSearchContainer listingsType={listingsType} breeds={breeds} />, element);
}
